import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { removeAccents } from '@saliente/library';
import { DimensionConfigurationsModel, DimensionValuesModel } from '../../expert/accnotes/accnotes.models';

@Component({
    selector: 'document-cost-center-dialog',
    templateUrl: 'document-cost-center-dialog.component.html',
    standalone: false
})
export class DocumentCostCenterDialogComponent implements OnInit {
	@Input() public dimensionConfig: DimensionConfigurationsModel[] = [];
	@Input() public costCenter: string;
	@Output() public save = new EventEmitter<string>();
	@Output() public close = new EventEmitter();

	@ViewChild('costCenterForm') public costCenterForm: NgForm;

	public dimensionValues: { [dimensionId: number]: string } = {};

	public filteredDimensionValues: { [dimensionId: number]: DimensionValuesModel[] } = {};

	public fallbackCostCenter: string = null;

	public get useFallback(): boolean {
		return !this.dimensionConfig || this.dimensionConfig.length === 0;
	}

	public ngOnInit() {
		if (this.useFallback) {
			this.fallbackCostCenter = this.costCenter || null;
			return;
		}
		let offset = 0;
		const cc = this.costCenter || '';
		this.dimensionConfig.forEach(d => {
			this.dimensionValues[d.dimensionId] = cc.substring(offset, offset + d.charSize).trimEnd();
			this.filteredDimensionValues[d.dimensionId] = d.dimensionValues || [];
			offset += d.charSize;
		});
	}

	public onSave() {
		if (!this.costCenterForm.valid) {
			return;
		}
		if (this.useFallback) {
			this.save.emit(this.fallbackCostCenter);
			return;
		}
		let result = '';
		this.dimensionConfig.forEach(d => {
			let val = (this.dimensionValues[d.dimensionId] || '').substring(0, d.charSize);
			result += val.padEnd(d.charSize, ' ');
		});
		this.save.emit(result.trimEnd());
	}

	public handleDimensionFilter(dimension: DimensionConfigurationsModel, searchText: string) {
		const values = dimension.dimensionValues || [];
		const search = removeAccents(searchText || '').toLowerCase();
		this.filteredDimensionValues[dimension.dimensionId] = search
			? values.filter(v =>
				removeAccents(v.name || '').toLowerCase().includes(search) ||
				removeAccents(v.code || '').toLowerCase().includes(search))
			: values;
	}

	public resetDimensionFilter(dimension: DimensionConfigurationsModel) {
		this.filteredDimensionValues[dimension.dimensionId] = dimension.dimensionValues || [];
	}
}
